import React from "react";
import { TableData } from "extranet-component-library";
import { useTranslation } from "react-i18next";

interface CustomProps {
  allLines: Array<any>;
  handleAdd: (data: any) => void;
}

const AllLines = ({ allLines, handleAdd }: CustomProps) => {
  const { t } = useTranslation();

  return (
    <>
      {allLines.length ? (
        <TableData
          rows={6}
          items={allLines}
          headers={[
            { id: "cod", label: t("code") },
            { id: "nam", label: t("name") },
            { id: "action", label: "" },
          ]}
          icon="star-o"
          icon_alt="star"
          onActionClick={(data: any) => handleAdd(data)}
        />
      ) : (
        <div className="no_items">{t("no_items")}</div>
      )}
    </>
  );
};

export default AllLines;
